import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { PiInfo } from "react-icons/pi";

/** Space above the hint, separating it from the last chat row or the empty-state
 * message. Included in CLOSED_CHATS_HINT_ROW_HEIGHT so virtualized rows fit it. */
export const CLOSED_CHATS_HINT_MARGIN_TOP = 20;

const ClosedChatsHintRow: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: `calc(100% - ${CLOSED_CHATS_HINT_MARGIN_TOP}px)`,
        mt: `${CLOSED_CHATS_HINT_MARGIN_TOP}px`,
        alignItems: "flex-start",
        gap: 0.75,
        pl: 2,
        pr: 3,
        py: "7px",
        borderRadius: "8px",
        border: "1px solid transparent",
        cursor: "default",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <PiInfo
        size={16}
        style={{
          flexShrink: 0,
          marginTop: 2,
          color: theme.palette.text.secondary,
        }}
      />

      <Typography
        sx={{
          fontStyle: "italic",
          fontSize: "0.75rem",
          lineHeight: "1rem",
          color: "text.secondary",
        }}
      >
        Can&apos;t find a chat? Some chats may be hidden by filters - adjust
        them to see more.
      </Typography>
    </Box>
  );
};

export default ClosedChatsHintRow;
